export const THEME_PROJECT = process.env.VUE_APP_PROJECT ? process.env.VUE_APP_PROJECT : 'xunke'; //对应模板号

export const STORAGE_TYPE = "localStorage"; //本地存储类型 sessionStorage、localStorage

export const SERVER_HOST = process.env.NODE_ENV === 'production' ? window.location.protocol + "//" + window.location.host : ''; //接口地址

export const TIME_OUT = 60000; //接口超时时间60s

export const APPLICATION_ID = 1; // 平台类型

export const VCODE_URL = `${SERVER_HOST}/ums/pub/user/v_code?codeKey=`; // 图片验证码的地址

export const UPLOAD_URL = `${SERVER_HOST}/pub/upload`; // 上传地址

export const PDF_URL = `${SERVER_HOST}/mbs/Amazon_store_ID_to_get_the_tutorial.pdf`; // 上传地址

export const UPLOAD_URL2 = `${SERVER_HOST}/pub/upload2?size=1024&unit=M`; // 上传地址，返回有效期为10年的链接